module.exports = "upcoming-events"